module.exports = __webpack_public_path__ + "img/legacy.294619ba.jpg";